import { createSlice } from '@reduxjs/toolkit';

let Slices = [];
let stateReducers = {};
let stateActions  = {};

/*---------------------------------------------------------------*/

export const deviceSlice = createSlice({
    name: 'deviceState',
    initialState: false,
    reducers: {
        setDeviceState: (state, action) => action.payload,
    },
});

Slices.push(deviceSlice);

/*---------------------------------------------------------------*/

export const loaderSlice = createSlice({
    name: 'loaderState',
    initialState: false,
    reducers: {
        setLoader: (state, action) => action.payload
    },
});

Slices.push(loaderSlice);

/*---------------------------------------------------------------*/

export const popupsSlice = createSlice({
    name: 'popupsArray',
    initialState: [],
    reducers: {
        addPopup: (state, action) => {
            state = state.push(action.payload)
        },
        removePopup: (state) => {
            state = state.pop();
        },
    },
})

Slices.push(popupsSlice);

/*---------------------------------------------------------------*/

export const requestingSlice = createSlice({
    name: 'requestingState',
    initialState: false,
    reducers: {
        requestStarted: (state, action) => true,
        requestEnded: (state, action) => false,
    },
});

Slices.push(requestingSlice);

/*---------------------------------------------------------------*/

export const burgerSlice = createSlice({
    name: 'burgerState',
    initialState: false,
    reducers: {
        setBurger: (state, action) => action.payload,
    },
});

Slices.push(burgerSlice);

/*---------------------------------------------------------------*/

export const pageScrollerSlice = createSlice({
    name: 'pageScrollerState',
    initialState: false,
    reducers: {
        setPageScroller: (state, action) => action.payload,
    },
});

Slices.push(pageScrollerSlice);

/*---------------------------------------------------------------*/

// Build export objects
for (const Slice of Slices) {
    let reducer   = { [Slice.name]: Slice.reducer };
    stateActions  = { ...stateActions, ...Slice.actions };
    stateReducers = { ...stateReducers, ...reducer };
}

export { stateActions };
export { stateReducers };
